import React from 'react'
import { AdminProducts } from '../../../../Components/Views'
import useProductsAdmin from '../../../../Hooks/ProductsAdmin'

const Render = () => {
    const props = useProductsAdmin();
    return (
        <AdminProducts {...props} />
    )
}

export default Render